( function () {
   
    'use strict';

    ( function ( $ ) {
      if($('.predictor-game-counter').length > 0){
        var time = $('#timerdae').val();
        if(time != ''){
          var countDownDate = new Date(time).getTime();

          // Update the countdown every 1 second
          var x = setInterval(function () {
            // Get today's date and time
            var now = new Date().getTime();
          
            // Find the distance between now and the countdown date
            var distance = countDownDate - now;
          
            // Calculate the days, hours, minutes and seconds left
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
            // Display the result in the HTML elements
            document.getElementById("days").innerHTML = days.toString().padStart(2, "0");
            document.getElementById("hours").innerHTML = hours
              .toString()
              .padStart(2, "0");
            document.getElementById("minutes").innerHTML = minutes
              .toString()
              .padStart(2, "0");
            document.getElementById("seconds").innerHTML = seconds
              .toString()
              .padStart(2, "0");
          
            // If the countdown is over, show a message
            if (distance < 0) {
              clearInterval(x);
              document.getElementById("countdown").innerHTML = "EXPIRED";
            }
          }, 1000);
        }
      }
        
    } )( jQuery );
} )();

